import { Builder } from '@builder.io/react'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import { getCognitoId } from 'components/util/UserId'
import { triggerTagging } from 'components/util/common-utils'
import React, { useEffect, useState } from 'react'
import LinkButton, { LinkButtonProp, LinkButtonRegisterProps } from '../common/button'

enum Position {
  Bottom = 'bottom',
  Top = 'top'
}

enum Animation {
  SingleLine = 'singleLine',
  VerticalCarousel = 'verticalCarousel'
}

interface Props {
  text: [{ text: string }]
  textAnimation: Animation
  imageAnimation: boolean
  backgroundColor: string
  fontColor: string
  footerPosition: Position
  buttonProps: LinkButtonProp
  trustpilotImage: string
  trustpilotMobileImage: string
  trustpilotMobileImageSmall: string
  ratingTextBold: string
  ratingTextNormalOne: string
  ratingTextNormalTwo: string
  ratingIcon: string
  builderRatingIcon: string
  showOnLoggedIn: boolean
}
const StickyFooter = ({
  text,
  textAnimation,
  imageAnimation,
  backgroundColor,
  fontColor,
  footerPosition,
  buttonProps,
  trustpilotImage,
  trustpilotMobileImage,
  trustpilotMobileImageSmall,
  ratingTextBold,
  ratingTextNormalOne,
  ratingTextNormalTwo,
  ratingIcon,
  builderRatingIcon,
  showOnLoggedIn
}: Props) => {
  const [showFooter, setShowFooter] = useState(false)
  const [footerDisplayForLoggedIn, setFooterDisplayForLoggedIn] = useState(true)
  const [scrollToSection, setScrollToSection] = useState<HTMLElement | null>(null)

  const [dogName, setDogName] = useState('')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Find the first element with an ID containing "Route"
      const matchingElement = Array.from(document.querySelectorAll<HTMLElement>('[id]')).find(el =>
        el.id.includes('Route')
      )

      if (matchingElement) {
        setScrollToSection(matchingElement as HTMLElement)
      }
    }
  }, [])

  useEffect(() => {
    const checkIfSignedIn = async () => {
      const username = await getCognitoId()
      if (username && !showOnLoggedIn) {
        setFooterDisplayForLoggedIn(false)
      } else {
        setFooterDisplayForLoggedIn(true)
      }
    }

    document.querySelector('body')?.addEventListener('mouseover', checkIfSignedIn)
    document.querySelector('body')?.addEventListener('touchstart', checkIfSignedIn)

    return () => {
      document.querySelector('body')?.removeEventListener('mouseover', checkIfSignedIn)
      document.querySelector('body')?.removeEventListener('touchstart', checkIfSignedIn)
    }
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 70) {
        setShowFooter(true)
      }
    }
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    // Listener for if dog name inputted to turbo route
    if (typeof window !== 'undefined') {
      const input = document.querySelector<HTMLInputElement>('#dogNameField')
      if (input) {
        setDogName(input.value)

        const handleInput = (event: Event) => {
          setDogName((event.target as HTMLInputElement).value)
        }

        input.addEventListener('input', handleInput)

        return () => {
          input.removeEventListener('input', handleInput)
        }
      }
    }
  }, [])

  const StickyWrapper = ({ children, position }: { children: any; position: Position }) => {
    const footerPositionClass = position === Position.Top ? 'top-0' : 'bottom-0'
    const transformClass = showFooter ? '-translate-y-0 opacity-100' : 'translate-y-150 opacity-0'

    return (
      <div
        id="stickyFooter"
        className={`${dogName && dogName.trim() !== '' ? 'hidden' : ''} fixed inset-x-0 z-50 ${footerPositionClass} ${transformClass} transition-transform duration-700 duration-3000 ease-in-out`}
      >
        {children}
      </div>
    )
  }

  const Content = ({
    text,
    textAnimation,
    imageAnimation,
    buttonProps,
    backgroundColor,
    fontColor,
    trustpilotImage,
    trustpilotMobileImage,
    trustpilotMobileImageSmall,
    ratingTextBold,
    ratingTextNormalOne,
    ratingTextNormalTwo,
    ratingIcon,
    builderRatingIcon
  }: any) => {
    const renderReviewCarousel = (text: any) => {
      const [currentIndex, setCurrentIndex] = useState(0)

      let duplicatedItems: any = []
      for (let i = 0; i < 50; i++) {
        duplicatedItems = duplicatedItems.concat(text)
      }

      useEffect(() => {
        const interval = setInterval(() => {
          setCurrentIndex(prevIndex => (prevIndex + 1) % duplicatedItems.length)
        }, 3000)

        return () => clearInterval(interval)
      }, [duplicatedItems.length])

      return (
        <>
          {duplicatedItems?.length > 0 && (
            <div className="relative h-12 overflow-hidden w-full ml-4">
              <div
                className="flex flex-col transition-transform duration-500 ease-in-out"
                style={{
                  transform: `translateY(-${currentIndex * 3}rem)`
                }}
              >
                {duplicatedItems.map((t: any, index: number) => (
                  <div
                    key={index}
                    className="flex items-center justify-left h-12 w-auto text-sm font-medium sm:text-base"
                  >
                    <p
                      className={`font-singleLine text-white text-center`}
                      dangerouslySetInnerHTML={{ __html: t.text }}
                    ></p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )
    }

    const renderImageCarousel = (trustpilotImage: any) => {
      const [currentIndex, setCurrentIndex] = useState(0)
      const imageOne = () => {
        return <img className="h-auto max-h-8 pr-4 w-auto" src={trustpilotImage} alt="Trustpilot" />
      }
      const imageTwo = () => {
        return (
          <div className="text-center text-sm lg:text-lg text-white">
            <span className="font-bold">{ratingTextBold} </span>
            <span>
              {ratingTextNormalOne}{' '}
              <CdnImage
                className="index-2 relative inline-block h-4 w-4"
                url={builderRatingIcon}
                alt={'Dog bowl'}
                lazyLoad={false}
              />
              {/* {builderRatingIcon ? (
                <CdnImage
                  className="index-2 relative inline-block h-4 w-4"
                  url={builderRatingIcon}
                  alt={'Dog bowl'}
                  lazyLoad={false}
                />
              ) : (
                <CloudinaryImage
                  className="index-2 relative inline-block h-4 w-4"
                  publicId={ratingIcon?.public_id}
                  alt={'Dog bowl'}
                  loading={'eager'}
                />
              )} */}
              {ratingTextNormalTwo}
            </span>
          </div>
        )
      }

      const imageArray = [imageOne(), imageTwo()]
      let duplicatedItems: any = []
      for (let i = 0; i < 50; i++) {
        duplicatedItems = duplicatedItems.concat(imageArray)
      }

      useEffect(() => {
        const interval = setInterval(() => {
          setCurrentIndex(prevIndex => (prevIndex + 1) % duplicatedItems.length)
        }, 3000)

        return () => clearInterval(interval)
      }, [duplicatedItems.length])

      return (
        <>
          {duplicatedItems?.length > 0 && (
            <div className="relative h-12 overflow-hidden">
              <div
                className="flex flex-col transition-transform duration-500 ease-in-out"
                style={{
                  transform: `translateY(-${currentIndex * 3}rem)`
                }}
              >
                {duplicatedItems.map((i: any, index: number) => (
                  <div
                    key={index}
                    className="flex items-center justify-center lg:justify-left h-12 text-sm font-medium sm:text-base"
                  >
                    {i}
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )
    }

    const renderImage = () => {
      if (!imageAnimation) {
        return (
          <>
            {/* Trustpilot image */}
            {trustpilotImage && (
              <img className="h-full max-h-20 mr-4 w-full hidden lg:block" src={trustpilotImage} alt="Trustpilot" />
            )}
            {trustpilotMobileImage && (
              <img
                className="h-auto max-h-20 mr-4 hidden sm:block lg:hidden"
                src={trustpilotMobileImage}
                alt="Trustpilot"
              />
            )}
            {trustpilotMobileImageSmall && (
              <img className="h-auto max-h-20 mr-4 block sm:hidden" src={trustpilotMobileImageSmall} alt="Trustpilot" />
            )}
          </>
        )
      }
      if (imageAnimation) {
        return (
          <>
            <div className="hidden lg:block">{renderImageCarousel(trustpilotImage)}</div>
            <div className="hidden sm:block lg:hidden">{renderImageCarousel(trustpilotMobileImage)}</div>
            <div className="block sm:hidden">{renderImageCarousel(trustpilotMobileImageSmall)}</div>
          </>
        )
      }
    }

    return (
      <div
        className="relative bg-indigo-600"
        style={{ backgroundColor: backgroundColor, color: fontColor, zIndex: '999' }}
      >
        <div className="mx-auto w-full lg:w-10/12 p-3 pb-0 sm:px-6 lg:px-8 lg:py-3">
          <div className="flex items-center justify-between sm:px-8 md:px-0 flex-col-reverse lg:flex-row">
            <div className="flex items-center flex-row w-full mx-auto justify-center lg:justify-between lg:mx-0 lg:w-2/3">
              <div className="w-full flex justify-center lg:justify-start">{renderImage()}</div>
              {textAnimation === 'singleLine' && (
                <p
                  className={'text-sm font-medium sm:text-base w-auto lg:w-full'}
                  style={{ color: fontColor }}
                  dangerouslySetInnerHTML={{ __html: text[0].text }}
                ></p>
              )}
              <div className="flex justify-center lg:justify-start w-full">
                {textAnimation === 'verticalCarousel' && renderReviewCarousel(text)}
              </div>
            </div>
            <div className="w-4/5 mx-auto sm:w-full md:w-full justify-center flex lg:w-auto lg:justify-end lg:mx-0">
              {scrollToSection ? (
                <button
                  className={`inline-block text-center bg-[#006685] text-white py-2 px-2 border border-transparent rounded-full font-medium`}
                  style={{ backgroundColor: buttonProps.buttonColor, color: buttonProps.buttonTextColor }}
                  onClick={() => {
                    triggerTagging(`desktop_navbar_cta_create_plan_${scrollToSection.id}`, `${scrollToSection.id}`)
                    scrollToSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
                  }}
                >
                  {buttonProps.buttonText || 'Get Started'}
                </button>
              ) : (
                <>
                  <LinkButton
                    buttonColor={buttonProps.buttonColor}
                    buttonText={buttonProps.buttonText}
                    loggedInButtonText={buttonProps.loggedInButtonText}
                    buttonTextColor={buttonProps.buttonTextColor}
                    buttonUrl={buttonProps.buttonUrl}
                    isLink={buttonProps.isLink}
                    classList={' w-full py-3 px-5 text-center rounded-full font-medium inline-block'}
                    onClick={() => {
                      if (typeof window.gtag !== 'undefined') {
                        window.gtag('event', 'cta_button_click', {
                          page: 'homepage'
                        })
                      }
                    }}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      {footerDisplayForLoggedIn && (
        <StickyWrapper position={footerPosition}>
          <Content
            text={text}
            textAnimation={textAnimation}
            imageAnimation={imageAnimation}
            buttonProps={buttonProps}
            backgroundColor={backgroundColor}
            fontColor={fontColor}
            trustpilotImage={trustpilotImage}
            trustpilotMobileImage={trustpilotMobileImage}
            trustpilotMobileImageSmall={trustpilotMobileImageSmall}
            ratingTextBold={ratingTextBold}
            ratingTextNormalOne={ratingTextNormalOne}
            ratingTextNormalTwo={ratingTextNormalTwo}
            ratingIcon={ratingIcon}
            builderRatingIcon={builderRatingIcon}
          />
        </StickyWrapper>
      )}
    </>
  )
}
export default StickyFooter
Builder.registerComponent(StickyFooter, {
  name: 'StickyFooter',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'green'
    },
    {
      name: 'footerPosition',
      type: 'string',
      defaultValue: 'top',
      enum: ['bottom', 'top']
    },
    {
      name: 'text',
      type: 'list',
      subFields: [{ name: 'text', type: 'richText' }],
      defaultValue: []
    },
    {
      name: 'textAnimation',
      type: 'string',
      defaultValue: 'verticalCarousel',
      enum: ['singleLine', 'verticalCarousel']
    },
    {
      name: 'imageAnimation',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'fontColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'trustpilotImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'trustpilotMobileImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'trustpilotMobileImageSmall',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      ...LinkButtonRegisterProps
    },
    {
      name: 'ratingTextBold',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'ratingTextNormalOne',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'ratingTextNormalTwo',
      type: 'text',
      defaultValue: ''
    },
    // {
    //   name: 'ratingIcon',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderRatingIcon',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'showOnLoggedIn',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
